document.addEventListener('DOMContentLoaded', function() {
    var blockStripeArea = document.querySelector('.block-stripes');

    if (blockStripeArea) {
        var stripeBlocks = blockStripeArea.querySelectorAll('.cta-page-block');
        var indexStripeBlocksMobile = 0;
        var indexStripeBlocksDesktop = 0;
        var validItemsDesktop = [];

        for (var i = 0; i < stripeBlocks.length; i++) {
            var item = stripeBlocks[i].parentElement;
            if (!item.closest('.article-content')) {
                indexStripeBlocksMobile++;
                item.classList.add('stripe-mobile');
                if (indexStripeBlocksMobile % 2 !== 0) {
                    item.classList.add('stripe-mobile--odd');
                } else {
                    item.classList.add('stripe-mobile--even');
                }
            }
        }

        for (var i = 0; i < stripeBlocks.length; i++) {
            var item = stripeBlocks[i];
            if (!item.closest('.article-content')) {
                if (item.parentElement.classList.contains('col-lg-6')) {
                    validItemsDesktop.push(item.closest('.container'));
                } else {
                    validItemsDesktop.push(item.parentElement);
                }
            }
        }

        for (var i = 0; i < validItemsDesktop.length; i++) {
            var vItem = validItemsDesktop[i];
            if (!item.closest('.article-content')) {
                indexStripeBlocksDesktop++;
                vItem.classList.add('stripe');
                if (indexStripeBlocksDesktop % 2 !== 0) {
                    vItem.classList.add('stripe--odd');
                } else {
                    vItem.classList.add('stripe--even');
                }
            }
        }
    }
});